var AppGlobals = /** @class */ (function () {
    function AppGlobals() {
        this.errorMessage = 'Something went wrong, Please try later!';
        this.userSuccess = 'New user added successfully';
    }
    return AppGlobals;
}());
export { AppGlobals };
